<template>
  <label
    data-component="CsToggle"
    class="inline-flex select-none items-center"
    :class="{
      'cursor-not-allowed opacity-25': isDisabled,
      'cursor-pointer': !isDisabled,
    }"
  >
    <div class="relative">
      <input
        :value="value"
        type="checkbox"
        class="sr-only"
        :disabled="isDisabled"
        @change="handleCheckboxChange"
      />
      <div
        class="block h-[18px] w-[26px] rounded-full"
        :class="{
          'bg-[#1F94FF]': value && !isDisabled,
          'bg-[#90879B]': !value || isDisabled,
        }"
      />
      <div
        :class="{ 'translate-x-[8px] bg-white': value }"
        class="dot absolute left-1 top-1 h-2.5 w-2.5 rounded-full bg-white transition"
      />
    </div>
  </label>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CsToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'change'],
  setup(props, { emit }) {
    const handleCheckboxChange = () => {
      if (props.isDisabled) return;

      emit('input', !props.value);
      emit('change', !props.value);
    };

    return {
      handleCheckboxChange,
    };
  },
});
</script>
